// PDF decoders only receive PNG pixels generated by canvas, never a source URL
// or the original (possibly data:) bytes of a logo. Keep optional logos optional.
export function imageToPdfPng(image) {
  const width = image?.naturalWidth;
  const height = image?.naturalHeight;
  if (!Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0) return null;
  const scale = Math.min(1, 2048 / Math.max(width, height));
  const canvas = document.createElement('canvas');
  canvas.width = Math.max(1, Math.round(width * scale));
  canvas.height = Math.max(1, Math.round(height * scale));
  try {
    const context = canvas.getContext('2d');
    if (!context) return null;
    context.drawImage(image, 0, 0, canvas.width, canvas.height);
    return canvas.toDataURL('image/png');
  } catch {
    // Cross-origin images without CORS must not prevent exporting the report.
    return null;
  }
}
